import React from 'react';
import { Link } from 'react-router-dom';
import useScrollAnimation from '../../Hooks/useScrollAnimation';
import './EventDetails.css';

const downloadBrochure = () => {
  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<title>EFFN Annual Conference 2026 – Official Brochure</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
  *{margin:0;padding:0;box-sizing:border-box;}
  body{font-family:'Inter',Arial,sans-serif;color:#1a1a2e;background:#fff;-webkit-print-color-adjust:exact;print-color-adjust:exact;}

  /* COVER */
  .cover{background:linear-gradient(150deg,#020c1b 0%,#0a1f3d 40%,#0d2f5e 70%,#0f3d7a 100%);color:#fff;padding:72px 64px 64px;position:relative;overflow:hidden;page-break-after:always;}
  .cover::before{content:'';position:absolute;top:-120px;right:-120px;width:480px;height:480px;border-radius:50%;background:radial-gradient(circle,rgba(56,189,248,0.12) 0%,transparent 65%);}
  .cover::after{content:'';position:absolute;bottom:-80px;left:-80px;width:320px;height:320px;border-radius:50%;background:radial-gradient(circle,rgba(99,102,241,0.1) 0%,transparent 65%);}
  .cover-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.025) 1px,transparent 1px);background-size:48px 48px;}
  .cover-inner{position:relative;z-index:2;}
  .cover-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(56,189,248,0.12);border:1px solid rgba(56,189,248,0.25);border-radius:40px;padding:7px 18px;font-size:11px;font-weight:700;letter-spacing:1.8px;text-transform:uppercase;color:#7dd3fc;margin-bottom:32px;}
  .cover h1{font-size:42px;font-weight:800;line-height:1.1;margin-bottom:20px;letter-spacing:-1.5px;max-width:640px;}
  .cover h1 span{background:linear-gradient(90deg,#38bdf8,#818cf8);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
  .cover-desc{font-size:16px;color:rgba(255,255,255,0.65);line-height:1.8;max-width:560px;margin-bottom:48px;font-weight:400;}
  .cover-divider{width:60px;height:3px;background:linear-gradient(90deg,#38bdf8,#818cf8);border-radius:2px;margin-bottom:40px;}
  .cover-meta{display:flex;gap:48px;flex-wrap:wrap;}
  .cover-meta-item label{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:rgba(255,255,255,0.45);display:block;margin-bottom:6px;font-weight:600;}
  .cover-meta-item span{font-size:14px;font-weight:700;color:#fff;}

  /* SECTIONS */
  .section{padding:52px 64px;border-bottom:1px solid #edf2f7;}
  .section:last-of-type{border-bottom:none;}
  .section-label{font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:2px;color:#0f2f8f;margin-bottom:10px;opacity:0.8;}
  .section h2{font-size:28px;font-weight:800;color:#020c1b;margin-bottom:18px;letter-spacing:-0.8px;line-height:1.2;}
  .section p{font-size:14.5px;line-height:1.85;color:#4a5568;margin-bottom:14px;}

  /* STATS */
  .stats{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:28px;}
  .stat-box{background:linear-gradient(150deg,#020c1b 0%,#0a1f3d 60%,#0d2f5e 100%);color:#fff;border-radius:16px;padding:28px 24px;text-align:center;position:relative;overflow:hidden;}
  .stat-box::before{content:'';position:absolute;top:-30px;right:-30px;width:100px;height:100px;border-radius:50%;background:rgba(56,189,248,0.1);}
  .stat-box .num{font-size:40px;font-weight:900;letter-spacing:-2px;margin-bottom:8px;background:linear-gradient(90deg,#38bdf8,#7dd3fc);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
  .stat-box .lbl{font-size:12px;color:rgba(255,255,255,0.7);font-weight:600;letter-spacing:0.3px;}

  /* HIGHLIGHTS GRID */
  .highlights{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-top:28px;}
  .highlight-item{background:#f8faff;border-radius:14px;padding:22px;border:1px solid #e8eef6;border-left:4px solid #0f2f8f;}
  .highlight-item h3{font-size:13.5px;font-weight:700;color:#020c1b;margin-bottom:7px;letter-spacing:-0.2px;}
  .highlight-item p{font-size:12.5px;color:#64748b;margin:0;line-height:1.65;}

  /* ATTEND LIST */
  .attend-list{list-style:none;margin-top:20px;}
  .attend-list li{display:flex;align-items:center;gap:14px;padding:14px 0;border-bottom:1px solid #f1f5f9;font-size:14.5px;color:#1a1a2e;font-weight:500;}
  .attend-list li:last-child{border-bottom:none;}
  .attend-list li::before{content:'✓';background:linear-gradient(135deg,#0f2f8f,#0a1f3d);color:#fff;width:24px;height:24px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;flex-shrink:0;}

  /* CTA */
  .cta-box{background:linear-gradient(150deg,#020c1b 0%,#0a1f3d 40%,#0d2f5e 70%,#0f3d7a 100%);color:#fff;padding:52px 64px;text-align:center;position:relative;overflow:hidden;}
  .cta-box::before{content:'';position:absolute;top:-80px;right:-80px;width:280px;height:280px;border-radius:50%;background:radial-gradient(circle,rgba(56,189,248,0.1) 0%,transparent 65%);}
  .cta-box::after{content:'';position:absolute;bottom:-60px;left:-60px;width:220px;height:220px;border-radius:50%;background:radial-gradient(circle,rgba(99,102,241,0.08) 0%,transparent 65%);}
  .cta-inner{position:relative;z-index:2;}
  .cta-box h2{font-size:30px;font-weight:800;margin-bottom:14px;letter-spacing:-0.8px;}
  .cta-box p{font-size:15px;color:rgba(255,255,255,0.65);margin-bottom:28px;line-height:1.75;}
  .cta-contact{display:inline-block;font-size:14px;font-weight:700;color:#fff;background:rgba(255,255,255,0.1);border:1.5px solid rgba(255,255,255,0.2);border-radius:10px;padding:12px 28px;letter-spacing:0.3px;}

  /* FOOTER */
  .footer{padding:22px 64px;background:#f8faff;display:flex;align-items:center;justify-content:space-between;border-top:1px solid #e8eef6;}
  .footer-brand{font-size:12px;font-weight:700;color:#0a1f3d;letter-spacing:-0.2px;}
  .footer-note{font-size:11px;color:#94a3b8;}

  @media print{
    body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
    .cover{page-break-after:always;}
  }
</style>
</head>
<body>

<div class="cover">
  <div class="cover-grid"></div>
  <div class="cover-inner">
    <div class="cover-badge">&#9670; Flagship Event 2026</div>
    <h1>Annual Global Freight<br/><span>Forwarders Conference</span></h1>
    <p class="cover-desc">A premier in-person gathering for trusted freight forwarding leaders worldwide. Connect, collaborate, and grow your global logistics network.</p>
    <div class="cover-divider"></div>
    <div class="cover-meta">
      <div class="cover-meta-item"><label>Organiser</label><span>Elite Freight Forwarders Network</span></div>
      <div class="cover-meta-item"><label>Edition</label><span>Annual 2026</span></div>
      <div class="cover-meta-item"><label>Format</label><span>In-Person Conference</span></div>
      <div class="cover-meta-item"><label>Duration</label><span>4 Days</span></div>
    </div>
  </div>
</div>

<div class="section">
  <div class="section-label">About the Event</div>
  <h2>Built for Strategic Global Connections</h2>
  <p>The EFFN Annual Conference brings together selected members and trusted partners of the network for structured networking, pre-scheduled meetings, and focused business discussions in a professional environment.</p>
  <p>The program is designed to foster high-value connections, strengthen long-term partnerships, and deliver measurable business outcomes across global logistics markets.</p>
  <div class="stats">
    <div class="stat-box"><div class="num">500+</div><div class="lbl">Expected Attendees</div></div>
    <div class="stat-box"><div class="num">50+</div><div class="lbl">Countries Represented</div></div>
    <div class="stat-box"><div class="num">4</div><div class="lbl">Days of Networking</div></div>
  </div>
</div>

<div class="section">
  <div class="section-label">Event Highlights</div>
  <h2>What to Expect</h2>
  <div class="highlights">
    <div class="highlight-item"><h3>Welcome Networking Reception</h3><p>An opening session for introductions and informal networking among global logistics professionals.</p></div>
    <div class="highlight-item"><h3>One-to-One Business Meetings</h3><p>Pre-arranged private meetings with potential partners for focused strategic discussions.</p></div>
    <div class="highlight-item"><h3>Flexible Meeting Formats</h3><p>A blend of structured sessions and open networking for productive collaboration.</p></div>
    <div class="highlight-item"><h3>Group Dining &amp; Networking</h3><p>Shared meal sessions to encourage relaxed interactions and strengthen relationships.</p></div>
    <div class="highlight-item"><h3>Closing Dinner &amp; Social Evening</h3><p>A concluding evening featuring fine dining and informal networking.</p></div>
    <div class="highlight-item"><h3>City Tour</h3><p>Explore the host city with guided tours showcasing local culture, landmarks, and business districts.</p></div>
  </div>
</div>

<div class="section">
  <div class="section-label">Who Should Attend</div>
  <h2>Designed for Senior Logistics Leaders</h2>
  <p>This event is exclusively designed for senior logistics professionals and decision-makers who are ready to expand their global network.</p>
  <ul class="attend-list">
    <li>Freight forwarding company owners</li>
    <li>Directors and senior management</li>
    <li>Business development and partnership leaders</li>
    <li>Approved network members and invited partners</li>
  </ul>
</div>

<div class="cta-box">
  <div class="cta-inner">
    <h2>Secure Your Participation</h2>
    <p>Participation is limited to maintain high-quality interactions and effective networking. Early confirmation is strongly recommended.</p>
     <a href="https://effnetwork.com/" target="_blank" class="cta-contact" style="text-decoration: none; color: inherit;">https://effnetwork.com/</a>
  </div>
</div>

<div class="footer">
  <div class="footer-brand">Elite Freight Forwarders Network (EFFN)</div>
  <div class="footer-note">&copy; 2026 EFFN. All rights reserved. For informational purposes only.</div>
</div>

</body>
</html>`;

  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const printWindow = window.open(url, '_blank');
  if (printWindow) {
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      URL.revokeObjectURL(url);
    };
  }
};

const EventDetails = () => {
  useScrollAnimation();

  const highlights = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: 'Welcome Networking Reception',
      description: 'An opening session for introductions and informal networking, fostering early connections among global logistics professionals.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      title: 'One-to-One Business Meeting Slots',
      description: 'Pre-arranged private meetings with potential partners, enabling focused discussions, strategic alignment, and high-value business opportunities.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      ),
      title: 'Flexible Meeting Formats',
      description: 'A blend of structured sessions and open networking, designed to support productive discussions, collaboration, and meaningful business engagement.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      title: 'Group Dining & Informal Networking',
      description: 'Shared meal sessions designed to encourage relaxed interactions, strengthen professional relationships, and foster meaningful business connections.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z" />
          <path d="M2 17l10 5 10-5" />
          <path d="M2 12l10 5 10-5" />
        </svg>
      ),
      title: 'Closing Dinner & Social Evening',
      description: 'A concluding evening featuring fine dining and informal networking, providing the perfect setting to strengthen connections and celebrate successful collaborations.'
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      ),
      title: 'City Tour',
      description: 'Explore the host city with guided tours showcasing local culture, landmarks, and business districts, providing a memorable experience beyond the conference.'
    }
  ];

  return (
    <div className="event-details-page">
      {/* Event Hero */}
      <section className="event-hero animate-fade-in">
        <div className="container">
          <div className="event-hero-content">
            <div className="event-badge animate-fade-in-down animate-delay-200">Flagship Event 2026</div>
            <h1 className="event-title animate-fade-in-up animate-delay-300">Annual Global Freight Forwarders Conference</h1>
            <p className="event-subtitle animate-fade-in-up animate-delay-400">
              A premier in-person gathering for trusted freight forwarding leaders worldwide.
            </p>
            <p className="event-description animate-fade-in-up animate-delay-500">
              Connect with senior freight forwarding professionals from around the world through focused networking, strategic discussions, and high-value collaboration. Build lasting partnerships, exchange industry insights, and explore new opportunities to drive international business growth.
            </p>
            <div className="event-hero-buttons animate-fade-in-up animate-delay-600">
              <Link to="/contact" className="btn-event-primary hover-lift">
                Join Now
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
              <button onClick={downloadBrochure} className="btn-event-secondary hover-lift">
                Download Brochure
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Event Overview */}
      <section className="event-overview-section scroll-reveal">
        <div className="container">
          <div className="overview-layout">
            <div className="overview-content">
              <div className="overview-label">EVENT OVERVIEW</div>
              <h2 className="overview-heading">Built for Strategic Global Connections</h2>
              <p className="overview-text">
                This annual conference brings together selected members and trusted partners of the network for structured networking, pre-scheduled meetings, and focused business discussions in a professional environment.
              </p>
              <p className="overview-text">
                The program is designed to foster high-value connections, strengthen long-term partnerships, and deliver measurable business outcomes across global logistics markets.
              </p>
              <div className="overview-benefits-panel">
                <div className="benefit-item">
                  <div className="benefit-icon-circle">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="benefit-text">City Tour</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon-circle">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="benefit-text">Pre-Scheduled Meetings</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon-circle">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="benefit-text">Professional Environment</span>
                </div>
                <div className="benefit-item">
                  <div className="benefit-icon-circle">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="benefit-text">Focused Business Development</span>
                </div>
              </div>
            </div>
            <div className="overview-metrics">
              <div className="metric-card metric-card-featured hover-lift animate-fade-in-up animate-delay-200">
                <div className="metric-icon-wrapper">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <div className="metric-value">500+</div>
                <div className="metric-label">Expected Attendees</div>
              </div>
              <div className="metric-card metric-card-standard hover-lift animate-fade-in-up animate-delay-300">
                <div className="metric-icon-wrapper">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>
                </div>
                <div className="metric-value">50+</div>
                <div className="metric-label">Countries Represented</div>
              </div>
              <div className="metric-card metric-card-standard hover-lift animate-fade-in-up animate-delay-400">
                <div className="metric-icon-wrapper">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </div>
                <div className="metric-value">4</div>
                <div className="metric-label">Days of Networking</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Highlights */}
      <section className="event-highlights-section scroll-reveal">
        <div className="container">
          <div className="section-header-center">
            <h2 className="section-title">Event Highlights</h2>
            <p className="section-subtitle">
              A strategically designed program focused on maximizing networking value and business growth opportunities.
            </p>
          </div>
          <div className="highlights-grid">
            {highlights.map((highlight, index) => (
              <div key={index} className={`highlight-card hover-lift animate-fade-in-up animate-delay-${(index + 1) * 100}`}>
                <div className="highlight-icon">{highlight.icon}</div>
                <h3 className="highlight-title">{highlight.title}</h3>
                <p className="highlight-description">{highlight.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who Should Attend */}
      <section className="who-attend-section scroll-reveal">
        <div className="container">
          <div className="who-attend-layout">
            <div className="who-attend-header">
              <h2 className="section-title">Who Should Attend</h2>
              <p className="section-description">
                This event is designed for senior logistics professionals and decision-makers.
              </p>
            </div>
            <div className="who-attend-content">
              <ul className="attend-list">
                <li className="animate-fade-in-up animate-delay-200">Freight forwarding company owners</li>
                <li className="animate-fade-in-up animate-delay-300">Directors and senior management</li>
                <li className="animate-fade-in-up animate-delay-400">Business development and partnership leaders</li>
                <li className="animate-fade-in-up animate-delay-500">Approved network members and invited partners</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Join CTA */}
      <section className="event-cta-section scroll-reveal">
        <div className="container">
          <div className="event-cta-card">
            <h2 className="cta-title">Secure Your Participation</h2>
            <p className="cta-description">
              Participation is limited to maintain high-quality interactions and effective networking opportunities. Early confirmation is strongly recommended to secure your place and maximize business potential.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-cta-primary hover-lift">
                Join Now
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </Link>
              <Link to="/contact" className="btn-cta-secondary hover-lift">
                Contact Us for Details
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventDetails;
